/** Building blocks used by the bar, exported for your own UIs. */
export { fuzzyMatch, matchItem, normalize, rank } from './core/search.js'
export type { FuzzyMatch, ItemMatch, RankedItem, RankOptions } from './core/search.js'
export { formatHotkey, isEditable, isMac, matchesHotkey, parseHotkey, SequenceMatcher } from './core/hotkeys.js'
export { Frecency } from './core/frecency.js'
export { defaultStorage, memoryStorage, scopedStorage } from './core/storage.js'
export { renderMarkdown, escapeHtml } from './ui/markdown.js'
export { icons, iconSvg } from './ui/icons.js'
export type { IconName } from './ui/icons.js'
export { copyText, defaultNavigate } from './ui/nav.js'
